import React from "react";
import { Box, Card, Typography, Button, LinearProgress, Grid } from "@mui/material";
import InventoryCard from "./DashboardCards/InventoryCard";
import QuestionCard from "./DashboardCards/QuestionCard";
import ProgressCard from "./DashboardCards/ProgressCard";
import Slider from "react-slick";

const DashboardCard = ({ data }) => {
  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    // variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Box sx={{ width: '100%', display: 'flex' }}>
      <Box sx={{ width: { xs: '100%' } }}>
        <Slider {...sliderSettings}>
          <Box sx={{ px: 1, display: 'flex', alignItems: 'stretch', minHeight: 260 }}>
            <InventoryCard data={data} />
          </Box>
          <Box sx={{ px: 1, display: 'flex', alignItems: 'stretch', minHeight: 260 }}>
            <ProgressCard progress={data.progress} />
          </Box>
          <Box sx={{ px: 1, display: 'flex', alignItems: 'stretch', minHeight: 260 }}>
            <QuestionCard data={data} />
          </Box>
        </Slider>
      </Box>
    </Box>
  );
};

export default DashboardCard;
